(function () {

    angular.module('cvsApp').directive('direction',
        [function () {

            return {

                restrict: 'E',

                templateUrl: '../storelocator/app/components/direction/direction.html',
                controller: ['$scope', '$timeout', '$rootScope', '$state', '$stateParams', 'getStoreLocationService', 'checkStoreopen', 'getAddressSuggestionService', 'limitToFilter', '$http', 'cvsAppData', 'webTrendsService', '$window',
                    function ($scope, $timeout, $rootScope, $state, $stateParams, GSLS, $checkStoreopen, GASS, limitToFilter, $http, CAD, WTS, $window) {

                        angular.element("#specialtySpinner").show();
                        angular.element("#loader").show();

                        $scope.DLC = this;
                        $scope.DLC.storeNumber = $stateParams.storeNumber || window.localStorage.getItem("storeNumber");

                        var utagObj = {};
                        utagObj.page_name = "Store Directions";
                        utagObj.page_category = "Store Directions";
                        utagObj.store_id = $scope.DLC.storeNumber;
                        WTS.webTrendsUtag("OBJ", utagObj);

                        $scope.DLC.driving = true;
                        $scope.DLC.walking = false;
                        $scope.DLC.selectedDestination = null;
                        $scope.DLC.listView = true;
                        $scope.DLC.mapView = true;
                        $scope.DLC.mapViewsize = false;
                        $scope.DLC.listViewsize = true;
                        $scope.DLC.showingDirection = false;
                        $scope.DLC.locations = [];
                        $scope.DLC.destination = [];
                        $scope.DLC.storeLocationError = false;
                        $scope.DLC.reviewStore = CAD.getReviewOrder();

                        if (CAD.getTokenType() === 'Guest') {
                            $scope.DLC.mapView = false;
                        }

                        $scope.DLC.closePopUp = function () {
                            $scope.$close();
                        }

                        $scope.DLC.closePopUp = function () {
                            $scope.$close();
                        }

                        $scope.DLC.getAddressSuggestion = function (query) {

                            $scope.DLC.locations = [];
                            $scope.DLC.destination = [];

                            if ($scope.DLC.selectedDestination.length >= 3) {
                                $rootScope.typeaheadDirectionsListValue = null;
                                GASS.getAddressSuggestionsData($scope.DLC.selectedDestination, getAddressSuggestion);
                            }

                        }

                        $scope.DLC.printDirection = function () {
                            $timeout($window.print, 0);
                        }

                        var tokenID, tokenType;
                        tokenID = CAD.getTokenId() ? CAD.getTokenId() : cvsUtility.queryMap.tokenId;
                        tokenType = CAD.getTokenType() ? CAD.getTokenType() : 'Login';
                        var storeName = true;

                        var storeNumber = '',
                            lati = '',
                            longi = '';

                        var storeDetails = {
                            apiKey: cvsUtility.queryMap.apikey,
                            address: storeName ? $scope.DLC.storeName : "",
                            storeNumber: $scope.DLC.storeNumber,
                            iPAddress: "",
                            latitude: lati ? lati : "",
                            longitude: longi ? longi : "",
                            radius: 10,
                            maxResults: 100,
                            tokenID: tokenID,
                            tokenType: tokenType,
                            driveThru: "N",
                            store24HR: "N",
                            carePlus: "N",
                            immunization: $scope.DLC.immunization ? 'Y' : 'N',
                            minuteClinic: $scope.DLC.minuteclinic ? 'Y' : 'N',
                            pharmacy24HR: $scope.DLC.Pharmacy24hr ? 'Y' : 'N'
                            // token: cvsUtility.queryMap.token,
                            //timeStamp: cvsUtility.queryMap.timeStamp ? cvsUtility.queryMap.timeStamp : (cvsUtility.queryMap.timestamp ? cvsUtility.queryMap.timestamp : '')
                        };

                        GSLS.getStoreLocation(storeDetails, storeSuccess, 'PZN');


                        if (cvsUtility.isMobile()) {

                            $scope.DLC.listView = false;
                            $scope.DLC.mapView = true;
                            $scope.DLC.isMobile = true;

                        }

                        function storeSuccess(data) {
                            $timeout(function () {
                                angular.element("#specialtySpinner").hide();
                                angular.element("#loader").hide();
                            }, 0);

                            if (data && data.SERVER_ERROR || data.header.statusCode === 8300) {
                                var pageError = cvsUtility.getPageError(data, 'NonFatal', 'getStoreLocations');

                                WTS.webTrendsUtag("LINK", {
                                    page_error: pageError
                                }, undefined);
                                $scope.DLC.storeLocationError = true;

                                return;
                            }

                            if (data && data.getError() == '') {
                                $scope.DLC.storeLocationError = false;
                                $scope.DLC.directionitem = [data.apiResponse.storeDetails.entry.length > 0 ? data.apiResponse.storeDetails.entry[0] : data.apiResponse.storeDetails.entry];
                                $scope.DLC.directionitem[0].content.properties.Latitude.__text = $scope.DLC.directionitem[0].content.properties.Latitude.__text.replace(/[\n\t\r]+/g, '');
                                $scope.DLC.directionitem[0].content.properties.Longitude.__text = $scope.DLC.directionitem[0].content.properties.Longitude.__text.replace(/[\n\t\r]+/g, '');

                                if (document.getElementById('directionMap')) {

                                    renderMap();

                                }

                            } else {
                                var pageError = cvsUtility.getPageError(data, 'Fatal', 'getStoreLocations');
                                WTS.webTrendsUtag("LINK", {
                                    page_error: pageError
                                }, undefined);
                            }

                        }


                        function renderMap() {

                            $scope.DLC.map = new Microsoft.Maps.Map(document.getElementById('directionMap'), {

                                credentials: 'AkezKYdo-i6Crmr6nW9y0Ce_72T-osA8SwDdbgvfMSrKL47FVwQOpjBRGW_ON5Aq',
                                mapTypeId: "r",
                                zoom: 12

                            });

                            $scope.DLC.map.setView({

                                center: new Microsoft.Maps.Location($scope.DLC.directionitem[0].content.properties.Latitude.__text, $scope.DLC.directionitem[0].content.properties.Longitude.__text),
                                zoom: 12

                            });

                            var pushpin = new Microsoft.Maps.Pushpin(new Microsoft.Maps.Location($scope.DLC.directionitem[0].content.properties.Latitude.__text,
                                $scope.DLC.directionitem[0].content.properties.Longitude.__text), {
                                icon: '../common/images/marker.png'

                            });

                            $scope.DLC.map.entities.push(pushpin);

                        }

                        $scope.DLC.checkOpen = function (item) {

                            var openStatus = $checkStoreopen.checkOpen(item);
                            return openStatus;

                        }



                        $scope.DLC.goToSearchFlow = function () {

                            $state.go('storelocator', {
                                reload: true
                            });
                        }



                        $scope.DLC.showMap = function (item) {

                            if (cvsUtility.isMobile()) {

                                if (item == 'list') {

                                    $scope.DLC.listView = true;
                                    $scope.DLC.mapView = false;

                                } else {

                                    $scope.DLC.mapView = true;
                                    $scope.DLC.listView = false;

                                }

                            } else {

                                if (item == 'list') {

                                    $scope.DLC.mapViewsize = false;
                                    $scope.DLC.listViewsize = true;
                                    $scope.DLC.listView = true;

                                } else {

                                    $scope.DLC.mapViewsize = true;
                                    $scope.DLC.listViewsize = false;
                                    $scope.DLC.listView = false;

                                }

                            }

                        }

                        $scope.DLC.getDirection = function () {

                            renderMap();

                            angular.element("#specialtySpinner").show();
                            angular.element("#loader").show();

                            var Latitude, Longitude;

                            /*angular.forEach($scope.DLC.locations, function(destination){

                             if($scope.DLC.selectedDestination === destination.Name){

                             Latitude = destination.GeocodePoint.Latitude;

                             Longitude = destination.GeocodePoint.Longitude;

                             }

                             });*/

                            if ($scope.DLC.selectedDestination && $scope.DLC.selectedDestination.hasOwnProperty('GeocodePoint')) {

                                Latitude = $scope.DLC.selectedDestination.GeocodePoint.Latitude;
                                Longitude = $scope.DLC.selectedDestination.GeocodePoint.Longitude;

                            } else if ($scope.DLC.destination.length > 0) {

                                Latitude = $scope.DLC.destination[0].GeocodePoint.Latitude;
                                Longitude = $scope.DLC.destination[0].GeocodePoint.Longitude;

                            }
                            try {

                                Microsoft.Maps.loadModule('Microsoft.Maps.Directions',

                                    function () {

                                        var directionsManager = new Microsoft.Maps.Directions.DirectionsManager($scope.DLC.map);

                                        // Set Route Mode to driving

                                        if ($scope.DLC.walking) {
                                            directionsManager.setRequestOptions({
                                                routeMode: Microsoft.Maps.Directions.RouteMode.walking
                                            });

                                        } else {

                                            directionsManager.setRequestOptions({
                                                routeMode: Microsoft.Maps.Directions.RouteMode.driving
                                            });

                                        }

                                        var waypoint1 = new Microsoft.Maps.Directions.Waypoint({
                                            address: $scope.DLC.selectedDestination.hasOwnProperty('Name') ? $scope.DLC.selectedDestination.Name : $scope.DLC.selectedDestination
                                        });

                                        /*var
                                            waypoint2 =
                                                new
                                                    Microsoft.Maps.Directions.Waypoint({

                                                    location:
                                                        new
                                                            Microsoft.Maps.Location($scope.DLC.directionitem[0].content.properties.Latitude.__text,
                                                            $scope.DLC.directionitem[0].content.properties.Longitude.__text)

                                                });*/
                                        var storeLoc = $scope.DLC.directionitem[0].content.properties;
                                        var waypoint2 = new Microsoft.Maps.Directions.Waypoint({
                                            address: storeLoc.AddressLine.__text + ',' + storeLoc.Locality.__text + ',' + storeLoc.AdminDistrict.__text + ',' + storeLoc.PostalCode.__text
                                        });

                                        directionsManager.addWaypoint(waypoint1);
                                        directionsManager.addWaypoint(waypoint2);

                                        // Set the element in which the itinerary will be rendered

                                        directionsManager.setRenderOptions({
                                            itineraryContainer: document.getElementById('directionPointers')
                                        });

                                        directionsManager.calculateDirections();

                                    });
                                $timeout(function () {
                                    $scope.DLC.showingDirection = true;
                                }, 0)

                            } catch (ex) {
                                console.log(ex);
                            }

                            angular.element("#specialtySpinner").hide();
                            angular.element("#loader").hide();

                        }



                        $scope.DLC.getLocationtomyplace = function () {

                            if (cvsUtility.isAndroid()) {

                                if (cvsUtility.queryMap.latitude &&
                                    cvsUtility.queryMap.latitude != '' &&
                                    cvsUtility.queryMap.longitude &&
                                    cvsUtility.queryMap.longitude != '') {

                                    findStore(cvsUtility.queryMap.latitude,
                                        cvsUtility.queryMap.longitude);

                                } else {

                                    drawDefaultNorthAmericaMap();

                                }

                            } else
                            if (navigator.geolocation) {

                                navigator.geolocation.getCurrentPosition(showDirectiontomyPosition,
                                    function (error) {

                                        $scope.SLC.map = new Microsoft.Maps.Map(document.getElementById('myMapL'), {

                                            credentials: $scope.SLC.mapKey,
                                            mapTypeId: "r",
                                            zoom: 0

                                        });

                                        drawDefaultNorthAmericaMap();

                                    });

                                //todo testing with static location position

                                // var locationPoints = {

                                // coords: {

                                // latitude: '42.191950',

                                // longitude: '-87.825350'

                                // }

                                // };

                                // showCurrentPositionStores(locationPoints);

                            } else {

                                drawDefaultNorthAmericaMap();

                            }

                        }



                        function
                        showDirectiontomyPosition(locationPoints) {

                            Microsoft.Maps.loadModule('Microsoft.Maps.Directions',
                                function () {

                                    var directionsManager = new Microsoft.Maps.Directions.DirectionsManager($scope.DLC.map);

                                    if ($scope.DLC.walking) {

                                        directionsManager.setRequestOptions({

                                            routeMode: Microsoft.Maps.Directions.RouteMode.walking

                                        });

                                    } else {

                                        directionsManager.setRequestOptions({

                                            routeMode: Microsoft.Maps.Directions.RouteMode.driving

                                        });

                                    }

                                    var waypoint1 = new Microsoft.Maps.Directions.Waypoint({

                                        location: new Microsoft.Maps.Location(locationPoints.coords.latitude, locationPoints.coords.longitude)

                                    });

                                    var waypoint2 = new Microsoft.Maps.Directions.Waypoint({

                                        location: new Microsoft.Maps.Location($scope.DLC.directionitem[0].content.properties.Latitude.__text,
                                            $scope.DLC.directionitem[0].content.properties.Longitude.__text)

                                    });

                                    directionsManager.addWaypoint(waypoint1);
                                    directionsManager.addWaypoint(waypoint2);

                                    // Set the element in which the itinerary will be rendered

                                    directionsManager.setRenderOptions({

                                        itineraryContainer: document.getElementById('directionPointers')

                                    });

                                    directionsManager.calculateDirections();

                                });

                        }



                        function getAddressSuggestion(data) {

                            var serviceCount;

                            serviceCount--;



                            if (serviceCount == 0) {

                                angular.element("#specialtySpinner").hide();
                                angular.element("#loader").hide();

                            }

                            if (data.SERVER_ERROR) {

                                /**logging**/

                                log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RefillDashboard) +
                                    loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
                                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) +
                                    loggerServiceHelper.setServiceName("getPatientInformation") +
                                    loggerServiceHelper.setStatus("ERROR") +
                                    loggerServiceHelper.setDescription("response " + JSON.stringify(data)));

                                // }

                                /**
                                 * sankar 02/10/2016 - SMP 009 - getAddressSuggestions service error
                                 * Modified page_error tag
                                 */

                                var pageError = cvsUtility.getPageError(data, 'Fatal', 'getAddressSuggestions');

                                // WTS.webTrendsUtag("LINK", {
                                // page_error: pageError
                                // });

                                //rPresc.ERROR = data;

                                return;

                            }



                            if (data.getError() === '') {

                                var destination = data.getAddressResponse().ResourceSet.Resources.Location;


                                if (_.isArray(destination) && Object.prototype.toString.call(destination) === '[object Array]') {

                                    angular.forEach(destination,
                                        function (location) {

                                            $scope.DLC.locations.push(location);

                                            $scope.DLC.destination.push(location);

                                        })

                                    /*$scope.DLC.locations
                                        = _.uniqBy($scope.DLC.locations)

                                    $scope.DLC.destination
                                        = _.uniqBy($scope.DLC.destination)*/
                                } else {

                                    $scope.DLC.locations.push(destination);
                                    $scope.DLC.destination.push(destination);

                                }
                                //return $scope.DLC.destination;

                                $rootScope.typeaheadDirectionsListValue =  $scope.DLC.destination;
                                $rootScope.destinationName = $scope.DLC.selectedDestination;
                                angular.element("#typeaheadDirectionsList").click();
                                angular.element("#typeaheadDirectionsList").focus();

                            } else {

                                /**
                                 * sankar 02/10/2016 - SMP 009 - getAddressSuggestions service error
                                 * Modified page_error tag
                                 */

                                var pageError = cvsUtility.getPageError(data, 'Fatal', 'getAddressSuggestions');

                                // WTS.webTrendsUtag("LINK", {
                                // page_error: pageError
                                // });

                                //rPresc.ERROR = {};
                                //rPresc.ERROR.ERROR_MSG = MMS.errorMsg('SERVER_ERROR');
                                //rPresc.ERROR.SERVER_ERROR = true;

                            }

                        }



                    }

                ]

            }

        }])

})();